module.exports = "<h2 id=jpex-trigger>Jpex.$trigger</h2> <p><code>Function(eventName, payload)</code><br>Triggers a specific hook when writing plugins.</p> <p>See <a href=/guide/plugins#hooks-events>plugins</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./src/content/api/trigger.md
// module id = 41
// module chunks = 0